import React from 'react';
import styled from 'styled-components';

export const Headers = styled.span`font-family: 'Playfair Display', serif;`;

interface HeaderWithSeparatorProps {
  as: any;
  upperSubHeader: string;
  header: string;
}

const Separator = styled.div`
  width: 64px;
  height: 1px;
  background: #C49A6C;
`;

const SeparatorHeader = styled.h1`
  font-family: 'Playfair Display', serif;
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 53px;
  letter-spacing: 0.06em;
  margin-top: 0;
`;

const UpperSubHeader = styled.p`
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  margin-bottom: 0;
  font-family: 'Roboto';
`;

export const HeaderWithSeparator = (
  { as, header, upperSubHeader }: HeaderWithSeparatorProps,
): JSX.Element => (
  <div>
    <UpperSubHeader>{upperSubHeader}</UpperSubHeader>
    <SeparatorHeader as={as}>
      {header}
    </SeparatorHeader>
    <Separator />
  </div>
);
